
import { defineComponent } from "vue";
import PlanContainerJournal from "@/components/journals/PlanContainerJournal/PlanContainerJournal.vue";

export default defineComponent({
  components: { PlanContainerJournal },
  props: {
    //модель родительского элемента
    parentModel: { required: true },
    isCalculation: { required: true },
    isSettingsOpen: { required: true },
  },
  methods: {},
  data() {
    return {};
  },
});
